import { SvgIcon, type SvgIconProps } from '@mui/material';

export interface ToolCategoryIconProps extends SvgIconProps {
  category: string;
}

const normalize = (category: string) => (category || '').trim().toLowerCase();

/**
 * Lightweight category icon that avoids importing the full MUI icons barrel.
 */
export const ToolCategoryIcon = ({ category, ...props }: ToolCategoryIconProps) => {
  const c = normalize(category);

  // All icons share the same 24x24 viewBox.
  if (c === 'timedate') {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M12 7v6l4 2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </SvgIcon>
    );
  }

  if (c === 'memory') {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <rect x="6" y="6" width="12" height="4" fill="none" stroke="currentColor" strokeWidth="2" />
        <rect x="6" y="10" width="12" height="4" fill="none" stroke="currentColor" strokeWidth="2" />
        <rect x="6" y="14" width="12" height="4" fill="none" stroke="currentColor" strokeWidth="2" />
      </SvgIcon>
    );
  }

  if (c === 'taskmanagement') {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <rect x="5" y="6" width="14" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M8 10l1.5 1.5L12 9" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 14h8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </SvgIcon>
    );
  }

  if (c === 'calculation') {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <rect x="6" y="6" width="12" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M12 9v6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M9 12h6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </SvgIcon>
    );
  }

  if (c === 'textprocessing') {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M7 7h10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 7v12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M9 19h6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </SvgIcon>
    );
  }

  if (c === 'dataformat') {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M9 7H7c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M15 7h2c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </SvgIcon>
    );
  }

  if (c === 'whiteboard') {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <rect x="4" y="6" width="16" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M8 20h8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </SvgIcon>
    );
  }

  if (c === 'web') {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M3 12h18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 3a14 14 0 0 1 0 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 3a14 14 0 0 0 0 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </SvgIcon>
    );
  }

  // Default/fallback icon.
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M8 12h8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

